import React, { Component } from 'react'
import { connect } from 'react-redux'
import Button from "@material-ui/core/Button";
import * as actionTypes from "../../../store/actions";
import { toast } from "react-toastify";
import $ from "jquery";
import Axios from 'axios';
import translator from '../../../utils/translator';

export class ProductAllowanceTableRow extends Component {

    state = {
        productAllowanceAmount: "",
        displaySaveButton: false,
        APIResponseMessage: ""
    }

	inputNumberBlockedChars = ['e', 'E', '+', '-'];

    deleteProductAllowance = async () => {
        $("#" + this.props.index).css("display", "none");
        let deleteProductAllowanceAPIUrl = this.props.APIUrl + "/settings/product-allowance/delete"
        let data = {
            productAllowanceId: this.props.productAllowanceId
        }
        await Axios.post(deleteProductAllowanceAPIUrl, data)
        return toast.success(translator('Misc', 'product_allowance_delete_success'), this.props.toastConfig);
    };

    saveProductAllowance = async () => {
        if(this.state.productAllowanceAmount === "") {
			return toast.error(translator('Misc', 'allowance_price_error'), this.toast_config);
        }

        let saveProductAllowanceAPIUrl = this.props.APIUrl + "/settings/product-allowance/update"
        let data = {
            productAllowanceId: this.props.productAllowanceId,
            updatedAmount: this.state.productAllowanceAmount
        }
        let saveProductAllowanceAPIResponse = await Axios.post(saveProductAllowanceAPIUrl, data)
        this.setState({ displaySaveButton: false });
        return toast.success(translator('Misc', 'product_allowance_update_success'), this.props.toastConfig);
    };

    componentDidMount() {
        this.setState({ productAllowanceAmount: this.props.productAllowanceAmount })
    }

    checkIfBlockedChar = event => {
		if(this.inputNumberBlockedChars.includes(event.key)) {
			event.preventDefault();
		}
	}

    render() {
        let buttons = (
            <td>
                <div class="edit-pricing-button-wrapper">
                    <Button
                        id="set-price-close-button"
                        onClick={this.deleteProductAllowance}
                        color="primary"
                    >
                        <i class="fa fa-window-close fa-2x" aria-hidden="true" />
                    </Button>
                    {(this.state.displaySaveButton) 
                        ?
                            <Button
                                id="set-price-close-button save-warehouse"
                                onClick={this.saveProductAllowance}
                                color="primary"
                            >
                                <i class="fa fad fa-check fa-2x" aria-hidden="true" />
                            </Button>
                        : null
                    }
                </div>
            </td>
        );
        return (
            <tr id={this.props.index}>
                <td id="tbody-header" scope="row">
                    <p>{this.props.trendProductId}</p>
                </td>
                <td id="tbody-header" scope="row">
                    <p>{this.props.productDescription[this.props.selected_language]}</p>
                </td>
                <td id="tbody-header" scope="row">
                    <input
                        type="number"
                        class="form-control settings-form "
                        placeholder="#"
                        value={this.state.productAllowanceAmount}
                        onKeyDown={event => this.checkIfBlockedChar(event)}
                        onChange={event =>
                            this.setState({ productAllowanceAmount: event.target.value })
                        }
                        onFocus={() => {
                            this.setState({ displaySaveButton: true })
                        }
                        }
                    />
                </td>
                {buttons}
            </tr>
        )
    }
}

const mapStateToProps = (state) => ({
    APIUrl: state.APIUrl,
	selected_language: state.selected_language,
})

const mapDispatchToProps = dispatch => {
    return {
        deleteProductAllowance: recordId =>
            dispatch({
                type: actionTypes.DELETE_CONSULTANT_WAWREHOUSE,
                recordId: recordId
            }),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductAllowanceTableRow)
